export const CLINIC_TERMS = 'https://about.curon.co/terms/clinic'

// 2026年12月1日付けの利用規約改定内容
export const CLINIC_TERMS_REVISION = 'https://micin.app.box.com/s/7ur9ks2nox5kklohtuzsoo0xwqmc66hw'

export const SMS_PINCODE_HELP = 'https://micin.my.site.com/FAQforCuronsmartpass/s/article/1770'

// オンライン診療の医療機関様向けセグメントボット
export const AI_CHAT_FAQ_FOR_DOCTORS =
  'https://miibo.jp/chat/7f59d02d-c214-4795-aeb5-03c66d297a5f19f12ab2c5484?name=%E3%82%AF%E3%83%AD%E3%83%B3%20AI%E3%82%A2%E3%82%B7%E3%82%B9%E3%82%BF%E3%83%B3%E3%83%88'

// クロンスマートパスの医療機関様向けセグメントボット
export const AI_CHAT_FAQ_FOR_CURON_SMARTPASS =
  'https://miibo.jp/chat/86f7db2a-8377-439c-8f24-86faa7ed0b3d19f12abbe1c61?name=%E3%82%AF%E3%83%AD%E3%83%B3%20AI%E3%82%A2%E3%82%B7%E3%82%B9%E3%82%BF%E3%83%B3%E3%83%88'

export const FAQ_FOR_DOCTORS = 'https://micin.my.site.com/FAQforDoctors/s/'

export const FAQ_FOR_CURON_SMARTPASS = 'https://micin.my.site.com/FAQforCuronsmartpass/s/'
